import { CognitoUserPool } from 'amazon-cognito-identity-js'

export function createUserPool(
  userPoolId: string,
  clientId: string,
): CognitoUserPool {
  return new CognitoUserPool({
    UserPoolId: userPoolId,
    ClientId: clientId,
  })
}
